var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStaff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 21.938,
    viewBox: "0 0 22 21.938",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -0.722)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.848 15.263)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M392.1,339.124v7.4h5.152v-.644A7.014,7.014,0,0,0,392.1,339.124Z",
    transform: "translate(-392.1 -339.124)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.44 15.014)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M158.433,333.342h-.726v3.888h-6.544v-3.888h-.726q-.284,0-.562.023v7.623H159v-7.623Q158.717,333.342,158.433,333.342Z",
    transform: "translate(-149.875 -333.342)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 15.263)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,345.877v.644H5.152v-7.4A7.014,7.014,0,0,0,0,345.877Z",
    transform: "translate(0 -339.124)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.016 15.014)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 3.968,
    height: 2.6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.126 4.243)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M129.421,82.654h-8.508a5.874,5.874,0,1,0,8.508,0Z",
    transform: "translate(-119.293 -82.654)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.598 0.722)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M180.565.722h-.675a3.225,3.225,0,0,0-3.064,2.233h6.8A3.225,3.225,0,0,0,180.565.722Z",
    transform: "translate(-176.825 -0.722)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaff);
export default __webpack_public_path__ + "static/media/staff.00f4c91b080578d2e34a75e93afbaf99.svg";
export { ForwardRef as ReactComponent };